import { AppDispatchNext } from 'actions/actions.typesNext'
import { goBackAction } from 'actions/route/routeAction'
import { pushShortCutNotificationAction } from 'actions/uninotice/noticeShortCutAction'
import { NotificationType } from 'components/presentational/Notifications/NotificationType'

/**
 * https://redmine.mamba.ru/issues/118261
 */
export const storefrontGenericErrorAction =
  () => (dispatch: AppDispatchNext) => {
    dispatch(pushShortCutNotificationAction(NotificationType.genericError))
    dispatch(goBackAction())
  }
